import { Tabs } from 'antd'
import { useSearchParams } from 'react-router-dom'

import { PageBreadcrumbs } from 'src/components'
import { useLocales } from 'src/locales'

import { NewbornDemandsTab } from '../components/NewbornDemandsTab'
import { NewbornInvestigationStatusTab } from '../components/NewbornInvestigationStatusTab'

const STATUS_TAB = 'status'
const DEMANDS_TAB = 'demands'

export const InstitutionPregnancyNewBornsInvestigations = () => {
  const { t } = useLocales()
  const [searchParams, setSearchParams] = useSearchParams()

  const activeKey =
    searchParams.get('tab') === DEMANDS_TAB ? DEMANDS_TAB : STATUS_TAB

  const onChange = (key: string) => {
    setSearchParams({ tab: key }, { replace: true })
  }

  return (
    <PageBreadcrumbs
      items={[{ title: t('persons.person_pregnancy') }]}
      title={t('pregnancy.newBorns_investigations')}
    >
      <Tabs
        activeKey={activeKey}
        onChange={onChange}
        destroyOnHidden
        items={[
          {
            key: STATUS_TAB,
            label: t('pregnancy.newborn_investigations_tabs.status'),
            children: <NewbornInvestigationStatusTab />
          },
          {
            key: DEMANDS_TAB,
            label: t('pregnancy.newborn_investigations_tabs.demands'),
            children: <NewbornDemandsTab />
          }
        ]}
      />
    </PageBreadcrumbs>
  )
}
